import NewItem from "./news-item.component";

export default NewItem;
